import { GlobalAppState } from '@state/store';

export const getPackageReferences = (state: GlobalAppState) => state.app.packageReferences;
